module.exports = __webpack_public_path__ + "img/Logo1.6a872e32.svg";